import React from 'react';

import { Button } from 'components/base/button';
import { Colors } from 'theme/colors';
import { FontSize } from 'theme/fonts';
import { Container } from 'theme/layout';
import { Regular } from 'theme/text';

const MOBILE_MARGIN = 30;
const DESKTOP_MARGIN = 40;

/**
 * Button used to get help when user gets an error in chat.
 *
 * @param props - Contact button props.
 */
export function ContactButton(props: Props) {
  const { onPress } = props;

  return (
    <Container as="div" width={188} mx="auto" mt={[MOBILE_MARGIN, MOBILE_MARGIN, DESKTOP_MARGIN]}>
      <Button
        rounded
        accentColor={Colors.gallery}
        onPress={onPress}
      >
        <Regular fontSize={FontSize.H4} color={Colors.black}>
          Report & get help
        </Regular>
      </Button>
    </Container>
  );
}
/* Type definitions */
interface Props {
  onPress(): void;
}
